// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:3098',
  WS_URL: import.meta.env.VITE_WS_URL || 'ws://localhost:3098',
  TIMEOUT: 30000,
};

// Blockchain Configuration
export const BLOCKCHAIN_CONFIG = {
  CHAIN_ID: parseInt(import.meta.env.VITE_CHAIN_ID || '1'),
  NETWORK_NAME: import.meta.env.VITE_NETWORK_NAME || 'Ethereum Mainnet',
  RPC_URL: import.meta.env.VITE_RPC_URL || 'https://eth-mainnet.g.alchemy.com/v2/your-api-key',
  BLOCK_EXPLORER: import.meta.env.VITE_BLOCK_EXPLORER || 'https://etherscan.io',
};

// Contract Addresses
export const CONTRACTS = {
  NDH_TOKEN: import.meta.env.VITE_NDH_TOKEN_ADDRESS || '0x0000000000000000000000000000000000000000',
  ENGLISH_AUCTION: import.meta.env.VITE_ENGLISH_AUCTION_ADDRESS || '0x0000000000000000000000000000000000000000',
  DUTCH_AUCTION: import.meta.env.VITE_DUTCH_AUCTION_ADDRESS || '0x0000000000000000000000000000000000000000',
  VICKREY_AUCTION: import.meta.env.VITE_VICKREY_AUCTION_ADDRESS || '0x0000000000000000000000000000000000000000',
  CANDLE_AUCTION: import.meta.env.VITE_CANDLE_AUCTION_ADDRESS || '0x0000000000000000000000000000000000000000',
  NDH_STAKING: import.meta.env.VITE_NDH_STAKING_ADDRESS || '0x0000000000000000000000000000000000000000',
  GOVERNOR: import.meta.env.VITE_GOVERNOR_ADDRESS || '0x0000000000000000000000000000000000000000',
  TIMELOCK: import.meta.env.VITE_TIMELOCK_ADDRESS || '0x0000000000000000000000000000000000000000',
  FRACTIONAL_NFT: import.meta.env.VITE_FRACTIONAL_NFT_ADDRESS || '0x0000000000000000000000000000000000000000',
  BUYBACK_BURN: import.meta.env.VITE_BUYBACK_BURN_ADDRESS || '0x0000000000000000000000000000000000000000',
};

// Staking Configuration
export const STAKING_CONFIG = {
  TIERS: {
    BRONZE: { minStake: 100, apy: 15, lockDays: 0, feeDiscount: 1 },
    SILVER: { minStake: 1000, apy: 20, lockDays: 30, feeDiscount: 1.5 },
    GOLD: { minStake: 5000, apy: 25, lockDays: 90, feeDiscount: 2 },
    PLATINUM: { minStake: 25000, apy: 30, lockDays: 180, feeDiscount: 2.5 },
  },
};

// Auction Configuration
export const AUCTION_CONFIG = {
  TYPES: {
    ENGLISH: {
      label: 'English Auction',
      description: 'Price increases with each bid. Highest bidder wins.',
      minDuration: 1, // hours
      maxDuration: 168, // 7 days
      antiSnipeExtension: 600, // 10 minutes in seconds
    },
    DUTCH: {
      label: 'Dutch Auction',
      description: 'Price decreases over time. First bid wins.',
      minDuration: 1,
      maxDuration: 168,
    },
    VICKREY: {
      label: 'Vickrey Auction',
      description: 'Sealed bids. Winner pays second-highest price.',
      minCommitDuration: 6, // hours
      maxCommitDuration: 72,
      minRevealDuration: 3,
      maxRevealDuration: 48,
    },
    CANDLE: {
      label: 'Candle Auction',
      description: 'Random end time. Discourages last-second bidding.',
      minDuration: 1,
      maxDuration: 168,
    },
  },
  BASE_FEE_PERCENT: 2.5,
};

// Governance Configuration
export const GOVERNANCE_CONFIG = {
  QUORUM: 1000000, // 1M NDH
  VOTING_PERIOD: 7 * 24 * 60 * 60, // 7 days in seconds
  TIMELOCK_DELAY: 48 * 60 * 60, // 48 hours
  MIN_PROPOSAL_STAKE: 10000, // 10K NDH
  PROPOSAL_CATEGORIES: ['Economics', 'Technical', 'Feature', 'Partnership', 'Community'],
};

// Fractional Configuration
export const FRACTIONAL_CONFIG = {
  AUTO_FRACTIONALIZE_THRESHOLD: 10, // ETH
  DEFAULT_TOTAL_SUPPLY: 10000,
  MIN_BUYOUT_OWNERSHIP: 10, // percentage
};

// Social Features Configuration
export const SOCIAL_CONFIG = {
  COPY_TRADING: {
    MAX_FOLLOW: 100,
    MIN_TRACK_RECORD: 10, // trades
  },
  LEADERBOARD: {
    TIME_RANGES: ['24h', '7d', '30d', 'All'],
    CATEGORIES: ['pnl', 'volume', 'followers'],
  },
};

// UI Configuration
export const UI_CONFIG = {
  ITEMS_PER_PAGE: 20,
  MAX_FILE_SIZE: 50 * 1024 * 1024, // 50MB
  SUPPORTED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ANIMATION_DURATION: 300,
};

// Toast Configuration
export const TOAST_CONFIG = {
  SUCCESS_DURATION: 3000,
  ERROR_DURATION: 5000,
  INFO_DURATION: 4000,
};

// External Links
export const EXTERNAL_LINKS = {
  DOCUMENTATION: 'https://docs.templum.dao',
  DISCORD: 'https://discord.gg/templum',
  TWITTER: 'https://twitter.com/TemplumDAO',
  GITHUB: 'https://github.com/nardiha/templum-dao',
  MEDIUM: 'https://medium.com/@templum-dao',
  UNISWAP_NDH: 'https://app.uniswap.org/#/swap?outputCurrency=0x...',
};

export default {
  API_CONFIG,
  BLOCKCHAIN_CONFIG,
  CONTRACTS,
  STAKING_CONFIG,
  AUCTION_CONFIG,
  GOVERNANCE_CONFIG,
  FRACTIONAL_CONFIG,
  SOCIAL_CONFIG,
  UI_CONFIG,
  TOAST_CONFIG,
  EXTERNAL_LINKS,
};
